import request from '@/utils/request'
import Vue from 'vue'

//银行列表
export function getFinancialProductsListPage(params) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/product/financial/getFinancialProductsListPage',
        params
    })
}
// 图片上传
export function uploadImg(data, params) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/brand/file/upload',
        data,
        params
    })
}
//新增贷款
export function addApplyLoan(data) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/product/financial/addApplyLoan',
        data,
    })
}


/*********************保险部分***********************/

export function getInsuranceSelectListByPage(data) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/services/fs-insurance-services/selectListByPage',
        data,
    })
}
// 保险服务详情接口  /services/fs-insurance-services/getById

export function getById(data) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/services/fs-insurance-services/getById',
        data,
    })
}
// 获取开户行卡的下拉框接口   /product/sys-dict-code/selectListByType
export function getBankCard(params) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/product/sys-dict-code/selectListByType',
        params,
    })
}